import { choose } from '../../utils/platform';
import FunctionSetsDesktop from './FunctionSets.desktop';
import FunctionSetsMobile from './FunctionSets.mobile';

// Platform chooser: the phone gets tap rows instead of a table.
export default choose(FunctionSetsDesktop, FunctionSetsMobile);
